import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";
import { PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { config } from "./config";
import { hasPrivacyOptOutSignal } from "./privacyControls";
import "./styles.css";

const posthogOptions = {
  api_host: config.posthogHost,
  capture_pageview: false,
  person_profiles: "identified_only" as const
};

const analyticsEnabled = Boolean(config.posthogKey) && !hasPrivacyOptOutSignal();
let analyticsReady = false;

if (analyticsEnabled) {
  try {
    if (!(posthog as { __loaded?: boolean }).__loaded) {
      posthog.init(config.posthogKey, posthogOptions);
    } else {
      posthog.set_config(posthogOptions);
    }
    analyticsReady = true;
  } catch (error) {
    console.warn("[webfunnel] PostHog init failed; continuing without blocking render", error);
  }
}

const root = document.getElementById("root")!;

createRoot(root).render(
  <StrictMode>
    {analyticsReady ? (
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </StrictMode>
);
